import { toPlatePlugin } from '@udecode/plate/react';

import { BaseTocPlugin } from '../lib';

export const TocPlugin = toPlatePlugin(BaseTocPlugin);
